<template lang="pug">
.mainWrapper-innerContent
  .mainWrapper-leftContent
    BreadCrumb(v-if="info" :breadcrumbList='breadcrumbs')
    GovAnnounceStory(:info="info" :staticData="data" :followStatus="followStatus")
  .mainWrapper-rightContent
    .sidebar--right
      RelatedGovAnnouncesBlock(
        v-if="!info.category"
        :title='data.articlePage.sectionTextRelatedGovAnnounce'
        type="govAnnounces"
        :params='params'
        :staticData='data.latestArticles'
      )
</template>
<script>
import BreadCrumb from '@/components/modules/breadcrumb/breadcrumb.vue';
import GovAnnounceStory from '@/components/modules/gov_announce_story/gov_announce_story.vue';
import RelatedGovAnnouncesBlock from '@/components/latest_articles/related_gov_announnces_block.vue';

export default {
  props: {
    data: Object
  },
  components: {
    BreadCrumb,
    RelatedGovAnnouncesBlock,
    GovAnnounceStory
  },
  data() {
    return {
      id: this.$route.query.govAnnounceId,
      breadcrumbs: [{ text: '首頁', link: '/' }],
      info: {
        comments: [],
        tag: {}
      },
      params: {
        id: this.$route.query.govAnnounceId,
        govOptionName: this.$route.query.govOptionName,
        govOptionId: this.$route.query.govOptionId,
        size: 6
      },
      followIds: [],
      followStatus: false,
      token: localStorage.getItem(this.$store.state.storageKeys.token),
      identity: localStorage.getItem(this.$store.state.storageKeys.identity)
    };
  },
  async created() {
    await this.getSingleGovAnnounce();
    this.breadcrumbs.push({
      text: '公共事務',
      link: '/gov-announces'
    });
  },
  methods: {
    async getSingleGovAnnounce() {
      let route, res;
      route =
        this.$store.state.URLs.api +
        '/' +
        this.$store.state.lang +
        this.$store.state.routes.getSingleGovAnnounce +
        '/' +
        this.id;
      res = await this.$axios.get(route).catch(() => this.$router.push('/'));
      this.info = res.data;
    }
  }
};
</script>
